export default "__VITE_ASSET__Co9Jnw$6__"